import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { ClowderConfig } from '../storan-constant';
import { Observable, Subject } from 'rxjs';

// import * as RecordRTC from 'recordrtc';
// import moment from 'moment';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AppSettings} from '../storan-constant';

interface RecordedAudioOutput {
  blob: Blob;
  title: string;
}

@Injectable({
  providedIn: 'root'
})

export class ClowderService {
  private stream: any;
  private recorder: any;
  private interval: any;
  private startTime: any;
  private _recorded = new Subject<RecordedAudioOutput>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();
  dataloopHeadersAPI = new HttpHeaders();
  headers = new HttpHeaders();
  headersOpen = new HttpHeaders();
  public baseURL = ClowderConfig.devBaseURL
  public defaultDataset = ClowderConfig.devDefaultDataset

  constructor(private http: HttpClient, private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document) { }
    public addDataLoopHeadersApi() {
      this.dataloopHeadersAPI = new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('Token')
      })

    }

  getAuthToken(): Observable<any> {
    const body = {
      "username": "service8@syngentaprocess.com",
      "password": "mw%kt*Uk>y",
      "type": "user_credentials"
    }
    // let headers = new HttpHeaders({
    //   'Access-Control-Allow-Origin': '*',
    // })
    return this.http.post<any>('https://syngenta-gate.dataloop.ai/token?default', body)
  }
  uploadImage(formData: FormData, datasetId: string) {
    this.addDataLoopHeadersApi();
    let appURL: string = `${this.baseURL}/datasets/${datasetId}/items`;
    return this.http.post<any>(appURL, formData, { headers: this.dataloopHeadersAPI });
  }

  // deleteImageMetadata(fileId) {
  //   return this.http.delete(`${this.baseURL}/files/${fileId}/metadata.jsonld?key=`)
  // }

  // deleteImage(fileId: string): Observable<any> {
  //   return this.http.delete(`${this.baseURL}/datasets/${this.defaultDataset}/items/${fileId}`).pipe(
  //     finalize(() => {
  //       setTimeout(() => this.spinner.hide(), 1000);
  //     }),
  //     catchError(error => {
  //       this.spinner.hide();
  //       console.error('Delete error:', error);
  //       return throwError(() => new Error('Failed to delete asset'));
  //     })
  //   );
  // }

  uploadImageMetadata(fileId: any, payload: any, owner: any) {
    this.addDataLoopHeadersApi();
    const jsonBody = {
      metadata: {
        user: payload
      }
    };
    return this.http.patch(`${this.baseURL}/items/${fileId}`, jsonBody,{ headers: this.dataloopHeadersAPI });

  }


  // getListCount(data, pagecount) {
  //   this.spinner.show();
  //   const body = {
  //     "resource": "items",
  //     "page": pagecount,
  //     "sort": {
  //       "metadata.user.MS-CreatedOn": "descending",
  //     }
  //   }
  //   let datasetId = data.id;
  //   return this.http.post(`${this.baseURL}/datasets/${datasetId}/query`, body).pipe(
  //     finalize(() => setTimeout(() => {
  //       this.spinner.hide()
  //     }, 1000))
  //   );
  // }

  /////////////////////////////////////// Start Audio Recording Methods /////////////////////////////////////

  getRecordedBlob(): Observable<RecordedAudioOutput> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  public generateThumbnail(videoFile: Blob): Promise<string> {
    const video: HTMLVideoElement = this.document.createElement('video');
    const canvas: HTMLCanvasElement = this.document.createElement('canvas');
  //const context: CanvasRenderingContext2D | null = canvas.getContext('2d');
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
    return new Promise<string>((resolve, reject) => {
      canvas.addEventListener('error', reject);
      video.addEventListener('error', reject);
      video.addEventListener('loadedmetadata', () => {
        video.currentTime = video.duration / 2;
      });
      video.addEventListener('seeked', () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        resolve(canvas.toDataURL());
      });
      if (videoFile.type) {
        video.setAttribute('type', videoFile.type);
      }
      video.preload = 'auto';
      video.src = window.URL.createObjectURL(videoFile);
      video.load();
    });
  }
  // startRecording() {

  //   if (this.recorder) {
  //     // It means recording is already started or it is already recording something
  //     return;
  //   }

  //   this._recordingTime.next('00:00');
  //   navigator.mediaDevices.getUserMedia({ audio: true }).then(s => {
  //     this.stream = s;
  //     this.record();
  //   }).catch(error => {
  //     this._recordingFailed.next("");
  //   });

  // }

  // abortRecording() {
  //   this.stopMedia();
  // }

  // private record() {

  //   this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
  //     type: 'audio',
  //     mimeType: 'audio/webm'
  //   });

  //   this.recorder.record();
  //   this.startTime = moment();
  //   this.interval = setInterval(
  //     () => {
  //       const currentTime = moment();
  //       const diffTime = moment.duration(currentTime.diff(this.startTime));
  //       const time = this.toString(diffTime.minutes()) + ':' + this.toString(diffTime.seconds());
  //       this._recordingTime.next(time);
  //     },
  //     1000
  //   );
  // }

  // private toString(value: any) {
  //   let val = value;
  //   if (!value) {
  //     val = '00';
  //   }
  //   if (value < 10) {
  //     val = '0' + value;
  //   }
  //   return val;
  // }

  // stopRecording() {

  //   if (this.recorder) {
  //     this.recorder.stop((blob: any) => {
  //       if (this.startTime) {
  //         const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
  //         this.stopMedia();
  //         this._recorded.next({ blob: blob, title: mp3Name });
  //       }
  //     }, () => {
  //       this.stopMedia();
  //       this._recordingFailed.next("");
  //     });
  //   }
  // }

  // private stopMedia() {
  //   if (this.recorder) {
  //     this.recorder = null;
  //     clearInterval(this.interval);
  //     this.startTime = null;
  //     if (this.stream) {
  //       this.stream.getAudioTracks().forEach((track: { stop: () => any; }) => track.stop());
  //       this.stream = null;
  //     }
  //   }
  // }
  /////////////////////////////////////// End  Audion Recording Methods ////////////////////////////////////
  public handleError(err: HttpErrorResponse) {
    let errMsg: any;
    if (err instanceof Error) {
      errMsg = err.message;
    } else {
      errMsg = err.status;
    }
    return throwError(errMsg);
  }
}

